import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Trash2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const DeleteDomainUsers = ({ onDone }) => {
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);

  const open = async () => {
    setBusy(true);
    try { setPreview((await api.get("/admin/test-accounts/domain-preview")).data); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const remove = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/test-accounts/delete-domain", { confirm: "DELETE" });
      toast.success(`Deleted ${data.deleted} test user${data.deleted === 1 ? "" : "s"} and ${data.records} related records`);
      setPreview(null); onDone?.();
    } catch (e) { toast.error(errMsg(e, "Delete failed")); } finally { setBusy(false); }
  };

  return (
    <>
      <button className="mm-btn !bg-mm-error inline-flex items-center gap-2 mt-4" disabled={busy} onClick={open} data-testid="admin-delete-test-users">
        {busy && !preview ? <Loader2 size={15} className="animate-spin" /> : <Trash2 size={15} />} Delete all test users (@test.com, @example.com)
      </button>
      {preview && (
        <Dialog open onOpenChange={(o) => !o && !busy && setPreview(null)}>
          <DialogContent className="max-w-md" data-testid="admin-delete-test-users-dialog">
            <DialogHeader>
              <DialogTitle>Delete {preview.count} test user{preview.count === 1 ? "" : "s"}?</DialogTitle>
              <DialogDescription>Every account on {preview.domains.join(" or ")} (admins included, except you), plus their sessions, check-ins, journals, supporters, payments and other data. This can't be undone.</DialogDescription>
            </DialogHeader>
            {preview.count > 0 ? (
              <div className="mm-soft p-3 text-xs space-y-0.5 max-h-48 overflow-y-auto" data-testid="admin-delete-test-users-samples">
                {preview.samples.map((e) => <div key={e} className="truncate">{e}</div>)}
                {preview.count > preview.samples.length && <div className="text-mm-muted">…and {preview.count - preview.samples.length} more</div>}
              </div>
            ) : <p className="text-sm text-mm-muted" data-testid="admin-delete-test-users-none">No @test.com or @example.com accounts found.</p>}
            <div className="flex gap-2 justify-end">
              <button className="mm-btn-ghost !py-2 !px-4 text-sm" disabled={busy} onClick={() => setPreview(null)} data-testid="admin-delete-test-users-cancel">Cancel</button>
              {preview.count > 0 && (
                <button className="mm-btn !bg-mm-error !py-2 !px-4 text-sm inline-flex items-center gap-2" disabled={busy} onClick={remove} data-testid="admin-delete-test-users-confirm">
                  {busy && <Loader2 size={14} className="animate-spin" />} Delete {preview.count} test user{preview.count === 1 ? "" : "s"}
                </button>
              )}
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
